import React, { useState,useEffect } from "react";
import "./MicrowaveOvenService.css";
import HeatingIssueRepair from "../images/Heating Issue Repair.webp";
import MicrowaveMaintenance from "../images/MicrowaveMaintenance.webp";
import OvenInstallation from "../images/OvenInstallation.webp";
import PowerFailureRepair from "../images/PowerFailureRepair.webp";
import MicrowaveDoorRepair from "../images/MicrowaveDoorRepair.webp";
import  DoorstepOvenService from "../images/Double Door Service.webp";
import MicrowaveOvenRepairSupport from "../images/Microwave Oven.webp";
import customer1 from "../images/cutomer1.webp";



function MicrowaveService() {
     useEffect(() => {
    
        document.title =
          "MicrowaveOven Service - Embarque Services";
    
      }, []);
  
    const [formData, setFormData] = useState({
      name: "",
      phone: "",
      location: "",
      issue: "",
    });
  
    const [loading, setLoading] = useState(false);
  
    const handleChange = (e) => {
  
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
  
    };
  
    const handleSubmit = async (e) => {
  
      e.preventDefault();
  
      setLoading(true);
  
      const sendData = {
        ...formData,
        toMail: "expresshelplinecare@gmail.com",
      };
  
      try {
  
        const res = await fetch(
          "https://form.e2ecrm.in/api/sendmail",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sendData),
          }
        );
  
        await res.json();
  
        alert(
          "Thank you! Your service request is confirmed. Our engineer will call you shortly."
        );
  
        setFormData({
          name: "",
          phone: "",
          location: "",
          issue: "",
        });
  
      } catch (err) {
  
        console.log(err);
  
        alert("Error sending form");
  
      } finally {
  
        setLoading(false);
  
      }
    };
  
  return (
   <>
   
      {/* SPINNER */}

      {loading && (

        <div className="spinner-overlay">

          <div className="spinner"></div>

        </div>

      )}

      {/* MICROWAVE HERO SECTION */}

      <div className="microwave-home">

        <section className="microwave-hero">

          {/* LEFT APPLIANCE */}

          <div className="microwave-appliance-section">

            {/* <img
              className="microwave-machine-img"
              src="https://cdn-icons-png.flaticon.com/512/3659/3659898.png"
              alt="Microwave Oven Service"
            /> */}

          </div>

          {/* CONTENT */}

          <div className="microwave-content">

            <h1>
              Microwave Oven <br />
              Repair & <br />
              Maintenance <br />
              Service At <br />
              Your Doorsteps
            </h1>

          </div>

          {/* FORM */}

          <div className="microwave-booking-form">

            <h2>
              +91 93639 29984
            </h2>

            <p>
              CALL US TODAY
            </p>

            <span>
              Register your microwave oven complaints
            </span>

            <form onSubmit={handleSubmit}>

              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="location"
                placeholder="Location"
                value={formData.location}
                onChange={handleChange}
                required
              />

              <textarea
                name="issue"
                placeholder="Describe the microwave oven issue..."
                value={formData.issue}
                onChange={handleChange}
              ></textarea>
          <p>Your personal information is handled responsibly and used only for the services you request.</p>

              <button type="submit">

                {loading ? "Sending..." : "SUBMIT"}

              </button>

            </form>

          </div>

        </section>

      </div>

{/* MICROWAVE ABOUT SECTION */}

<section className="microwave-about-section">

  <div className="microwave-about-left">

    <h1>
      Trusted Microwave <br />
      Oven Repair <br />
      Experts for <br />
      Your Kitchen <br />
      Needs
    </h1>

    <div className="microwave-about-box">

      <p>
        With 8+ years of experience in microwave oven repair,
        our technicians provide fast and reliable doorstep support.
      </p>

      <p>
        From heating issues to motherboard and power problems,
        we repair all major microwave oven brands professionally.
      </p>

    </div>

  </div>

  <div className="microwave-about-right">

    <h4>
      OUR SERVICE ACHIEVEMENTS
    </h4>

    <div className="microwave-counter-grid">

      <div className="microwave-counter-box">
        <h1>8+</h1>
        <p>Years Experience</p>
      </div>

      <div className="microwave-counter-box">
        <h1>30000+</h1>
        <p>Oven Repairs</p>
      </div>

      <div className="microwave-counter-box">
        <h1>60+</h1>
        <p> Experienced Technicians </p>
      </div>

      <div className="microwave-counter-box">
        <h1>18+</h1>
        <p>Multiple Service Areas Covered</p>
      </div>

    </div>

  </div>

</section>


{/* MICROWAVE OVEN SERVICES SECTION */}

<section className="microwave-services-section">

  <h1 className="microwave-service-title">
    Our Microwave Oven Services
  </h1>

  <div className="microwave-services-grid">

    {/* CARD 1 */}

    <div className="microwave-service-card">

      <img
        src={HeatingIssueRepair} alt="heating issue"
      />

      <h2>
        Heating Issue Repair
      </h2>

      <p>
        Professional repair solutions for microwave ovens
        not heating food properly.
      </p>

    </div>

    {/* CARD 2 */}

    <div className="microwave-service-card">

      <img
        src={MicrowaveMaintenance} alt="microwave maintenance"
      />

      <h2>
        Microwave Maintenance
      </h2>

      <p>
        Regular servicing and maintenance support
        to improve microwave oven performance.
      </p>

    </div>

    {/* CARD 3 */}

    <div className="microwave-service-card">

      <img
        src={OvenInstallation} alt="installation"
      />

      <h2>
        Oven Installation
      </h2>

      <p>
        Safe microwave oven installation and setup
        support for homes and kitchens.
      </p>

    </div>

    {/* CARD 4 */}

    <div className="microwave-service-card">

      <img
        src={PowerFailureRepair} alt="power issue"
      />

      <h2>
        Power Failure Repair
      </h2>

      <p>
        Fast repair support for power issues,
        display failure, and motherboard problems.
      </p>

    </div>

    {/* CARD 5 */}

    <div className="microwave-service-card">

      <img
        src={MicrowaveDoorRepair} alt="door repair"
      />

      <h2>
        Microwave Door Repair
      </h2>

      <p>
        Expert support for microwave oven door lock,
        switch, and sensor related issues.
      </p>

    </div>

    {/* CARD 6 */}

    <div className="microwave-service-card">

      <img
        src={DoorstepOvenService} alt="doorstep service"
      />

      <h2>
        Doorstep Oven Service
      </h2>

      <p>
        Quick doorstep microwave oven repair support
        from experienced technicians.
      </p>

    </div>

  </div>

</section>

{/* MICROWAVE WHY CHOOSE US */}

<section className="microwave-choose-section">

  <div className="microwave-choose-overlay">

    <h4>
      WHY CHOOSE OUR MICROWAVE SERVICE
    </h4>

    <h1>
      Trusted Microwave <br />
      Oven Repair Solutions
    </h1>

    <div className="microwave-choose-grid">

      {/* BOX 1 */}

      <div className="microwave-choose-box">

        <div className="microwave-choose-icon">
          🔥
        </div>

        <h2>
          Expert Oven Repair
        </h2>

      </div>

      {/* BOX 2 */}

      <div className="microwave-choose-box">

        <div className="microwave-choose-icon">
          ⏰
        </div>

        <h2>
          Same Day Service
        </h2>

      </div>

      {/* BOX 3 */}

      <div className="microwave-choose-box">

        <div className="microwave-choose-icon">
          💰
        </div>

        <h2>
          Affordable Pricing
        </h2>

      </div>

      {/* BOX 4 */}

      <div className="microwave-choose-box">

        <div className="microwave-choose-icon">
          🚚
        </div>

        <h2>
          Doorstep Support
        </h2>

      </div>

      {/* BOX 5 */}

      <div className="microwave-choose-box">

        <div className="microwave-choose-icon">
          ⚡
        </div>

        <h2>
          Power Issue Solutions
        </h2>

      </div>

      {/* BOX 6 */}

      <div className="microwave-choose-box">

        <div className="microwave-choose-icon">
          👨‍🔧
        </div>

        <h2>
          Experienced Technicians
        </h2>

      </div>

    </div>

  </div>

</section>

{/* MICROWAVE OVEN REQUEST INFO */}

<section className="microwave-request-section">

  {/* Left Content */}

  <div className="microwave-request-left">

    <h1>
      Microwave Oven <br />
      Repair Support
    </h1>

    <h2>
      Fast & Reliable <br />
      Microwave Service at <br />
      Your Doorstep
    </h2>

    <p>
      We provide complete microwave oven repair and maintenance
      solutions for homes and commercial kitchens. Our experienced
      technicians handle heating problems, power failure,
      display issues, motherboard repair, installation,
      and servicing with professional doorstep support
      at affordable pricing.
    </p>

  </div>

  {/* Right Image */}

  <div className="microwave-request-right">

    <img
      src={MicrowaveOvenRepairSupport}  alt="microwave oven service"
    />

  </div>

</section>

{/* MICROWAVE OVEN CUSTOMER SUPPORT */}

{/* <section className="microwave-support-section">

 

  <div className="microwave-support-image">

    <img
      src={customer1}alt="microwave customer support"
    />

  </div>

 

  <div className="microwave-support-content">

    <h1>
      Microwave Oven Customer Support
    </h1>

    

    <div className="microwave-support-box">
      <span>+</span>
      <p>Quick Booking Through Call & WhatsApp</p>
    </div>

    <div className="microwave-support-box">
      <span>+</span>
      <p>Same Day Technician Visit</p>
    </div>

    <div className="microwave-support-box">
      <span>+</span>
      <p>Professional Microwave Repair Support</p>
    </div>

    <div className="microwave-support-box">
      <span>+</span>
      <p>Experienced Oven Repair Technicians</p>
    </div>

    <div className="microwave-support-box">
      <span>+</span>
      <p>Affordable Microwave Service Charges</p>
    </div>

  </div>

</section> */}

{/* MICROWAVE OVEN FAQ SECTION */}

{/* <section className="microwave-faq-section">

  <div className="microwave-faq-title">

    <h4>
      FAQ
    </h4>

    <h1>
      Microwave Oven Service Questions
    </h1>

  </div>

  <div className="microwave-faq-container">

    

    <div className="microwave-faq-box">

      <h2>
        What microwave oven issues do you repair?
      </h2>

      <p>
        We repair heating issues, power failure,
        display problems, motherboard faults,
        and unusual noise issues.
      </p>

    </div>

    
    <div className="microwave-faq-box">

      <h2>
        Do you repair all microwave oven brands?
      </h2>

      <p>
        Yes, we provide repair and maintenance
        support for all major microwave oven brands.
      </p>

    </div>

    

    <div className="microwave-faq-box">

      <h2>
        Do you provide doorstep microwave service?
      </h2>

      <p>
        Yes, our technicians provide fast doorstep
        microwave oven repair and inspection support.
      </p>

    </div>

  

    <div className="microwave-faq-box">

      <h2>
        How quickly can I book a microwave service?
      </h2>

      <p>
        You can instantly book your microwave oven
        service through phone call or WhatsApp support.
      </p>

    </div>


    <div className="microwave-faq-box">

      <h2>
        Do you provide motherboard repair support?
      </h2>

      <p>
        Yes, we provide professional motherboard
        repair and replacement support for ovens.
      </p>

    </div>

 
    <div className="microwave-faq-box">

      <h2>
        Are your microwave service charges affordable?
      </h2>

      <p>
        Yes, we provide transparent and affordable
        microwave oven repair pricing with quality service.
      </p>

    </div>

  </div>

</section> */}
<section class="working-hours-section">
  <div class="container">
    <div class="working-hours-box">
      <h2>Working Hours</h2>

      <div class="working-time">
        <span>Monday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Tuesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Wednesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Thursday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Friday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Saturday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Sunday</span>
        <strong>Closed</strong>
      </div>
    </div>
  </div>
</section>


<section className="service-info-section">
  <div className="service-info-container">

    <div className="service-info-header">
      <span>SERVICE DETAILS</span>
      <h2>Service Information</h2>

      <p>
        Clear information about our service charges and repair process.
      </p>
    </div>

    <div className="service-charge-box">

      <div className="service-check-icon">
        ✓
      </div>

      <div className="service-charge-content">

        <h3>Service Charge</h3>

        <div className="service-price">
          ₹400+
        </div>

        <p>
          The applicable basic service charge starts from ₹400.
          If any spare parts need replacement, our technician will
          explain the issue and inform you of the applicable cost
          before proceeding.
        </p>

        <div className="service-approval-note">
          <span>✓</span>

          <p>
            Spare part replacement or additional repair work will be
            carried out only after receiving your approval.
          </p>
        </div>

      </div>

    </div>

  </div>
</section>

   </>
  );
}

export default MicrowaveService;